export default __webpack_public_path__ + "static/media/17.689b6a67.jpeg";